export default function Card({title, opis})
{
 return (
    <div style={{
      border: "1px solid #4b4949ff",
      borderRadius: "5px",
      padding: "20px",
      width: "200px",
      margin: "50px",
      textAlign: "center"
    }}>
      <h3>{title}</h3>
      <p>{opis}</p>
      <br/>
    </div>
  );
}